import WorkspacePremiumRounded from "@mui/icons-material/WorkspacePremiumRounded";
import { Chip, ListItem } from "@mui/material";
import type { AchievementResponse } from "@bw/shared/types/generated";
import { humanize } from "./competeDisplay";

export function AchievementBadge({
  achievement,
}: {
  achievement: AchievementResponse;
}) {
  return (
    <ListItem
      disablePadding
      data-type={achievement.type}
      sx={{ width: "auto" }}
    >
      <Chip
        icon={<WorkspacePremiumRounded aria-hidden />}
        label={humanize(achievement.type)}
        color="primary"
        variant="outlined"
      />
    </ListItem>
  );
}
